import React from 'react';
import PropTypes from "prop-types";
import Chart from "react-apexcharts";

const ProductionTTAPieChart = (props) => {
    const INITIAL: any = []
    const [pieChartData, setPieChartData] = React.useState(INITIAL);
    const [pieChartOptions, setPieChartOptions] = React.useState({});

    React.useEffect(() => {
        let series = [];
        let labels = []
        !!props.labels ? labels = props.labels : labels = [];

        if (!!props.series) {
            series = props.series;

        }
        setPieChartOptions({
            chart: {
                toolbar: {
                    show: true
                },
                zoom: {
                    enabled: true
                },
                type: "donut"
            },
            title: {
                text: 'Total Time Analysis',
            },
            legend: {
                show: true,
                position: 'left'
            },
            colors: ['#05D20D', '#f44336'],
            fill: {
                opacity: 1,
            },
            dataLabels: {
                enabled: true,

            },
            labels: labels,
        })

        setPieChartData(series)
    }, [props])

    return (
        <Chart options={pieChartOptions} series={pieChartData} type='donut' width={props.width} height={props.height} />
    )
}

ProductionTTAPieChart.propTypes = {
    series: PropTypes.array.isRequired,
    labels: PropTypes.array.isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

export default ProductionTTAPieChart;